import React from 'react';
import clsx from 'clsx';
import { Button, Modal } from 'antd';
import styles from './ConfirmationModal.module.less';

type ConfirmationModalProps = {
  title?: React.ReactNode;
  visible: boolean;
  children: React.ReactNode;
  confirmText?: string;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  className?: string;
  width?: string | number;
  destroyOnClose?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  afterClose?: () => void;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  visible,
  children,
  confirmText = 'Confirm',
  confirmDisabled,
  confirmLoading,
  className,
  width,
  destroyOnClose,
  onClose,
  onConfirm,
  afterClose,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      title={title}
      onCancel={onClose}
      visible={visible}
      className={clsx(styles.container, className)}
      width={width}
      destroyOnClose={destroyOnClose}
      afterClose={afterClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" disabled={confirmDisabled} loading={confirmLoading} onClick={handleConfirm}>
            {confirmText}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModal;
